import * as Constants from '../constants';

const localstorageKeys = ['systemConfig','i18n'];

export const getKeyFromLS = (LOCAL_STORAGE_DATA_KEY) => {
    try {
        let locationState = sessionStorage.getItem(LOCAL_STORAGE_DATA_KEY);
        if(localstorageKeys.includes(LOCAL_STORAGE_DATA_KEY)){
            locationState = localStorage.getItem(LOCAL_STORAGE_DATA_KEY);
        }
        
        if (locationState) {
            return JSON.parse(locationState);
        } else {
            return undefined;
        }
    } catch (e) {

    }
}

export const resetActiveSchool = (newActiveSchool) => {
    let currentObj = getKeyFromLS(Constants.STEPPER_STATE_KEY_LS) || {};
    currentObj.activeSchool = newActiveSchool;
    setDataInLS(Constants.STEPPER_STATE_KEY_LS,currentObj);
}
export const setDataInLS = (LOCAL_STORAGE_DATA_KEY, data) => {
    try {
        if(localstorageKeys.includes(LOCAL_STORAGE_DATA_KEY)){
            localStorage.setItem(LOCAL_STORAGE_DATA_KEY, JSON.stringify(data));
        }else{
            sessionStorage.setItem(LOCAL_STORAGE_DATA_KEY, JSON.stringify(data));
        }
        



    } catch (e) {
        console.log("Not able to set locastorage");
    }
}


export const removeDataInLS = (LOCAL_STORAGE_DATA_KEY) => {
    try {

        sessionStorage.removeItem(LOCAL_STORAGE_DATA_KEY);


    } catch (e) {
        console.log("Not able to remove locastorage");
    }
}

export const getActiveScheduleIndex = (school,scheduleId) =>{
    let scheduleConstraints = JSON.parse(JSON.stringify(school.schedule_constraints));
    let index = scheduleConstraints.findIndex((schedule_constraint) => schedule_constraint._id == scheduleId);
     return index;
}